import dayjs from 'dayjs'

// Mốc hết hiệu lực thực tế của 1 thông báo, theo thứ tự ưu tiên: time_close nếu có -> hết ngày
// time_open nếu có -> hết ngày created (bản ghi hiếm gặp thiếu cả time_open) -> luôn hiệu lực (chỉ
// khi thiếu hết mọi mốc thời gian - created luôn tồn tại nên gần như không rơi vào đây). Phải khớp
// 1-1 với Announcement::effectiveEndSql() ở backend (2 nguồn tính cùng 1 khái niệm - lệch nhau sẽ
// khiến badge "hết hạn" trên FE và filter status=1 ở BE không đồng nhất).
export const isAnnouncementExpired = ({time_open, time_close, created} = {}) => {
    if (time_close) return dayjs(time_close).isBefore(dayjs())
    if (time_open) return dayjs(time_open).endOf('day').isBefore(dayjs())
    if (created) return dayjs(created).endOf('day').isBefore(dayjs())
    return false
}
